export default __webpack_public_path__ + "static/samoa-f19960fb2b4601f9fe86666b9d907aaf.jpg";